import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgExitLeftLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M10 22a1 1 0 1 1 0-2c2.7 0 4.69-.675 6.008-1.992S18 14.7 18 12s-.675-4.69-1.992-6.008S12.7 4 10 4a1 1 0 0 1 0-2c3.007 0 5.597.753 7.422 2.578S20 8.993 20 12s-.753 5.597-2.578 7.422S13.007 22 10 22'
    />
    <path
      fill={props.color}
      d='M9.94 8.818a1 1 0 0 0-1.708-.707L5.05 11.293a1 1 0 0 0 0 1.414l3.182 3.182a1 1 0 0 0 1.707-.707V13h4.304a1 1 0 1 0 0-2H9.939z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgExitLeftLine)
export default ForwardRef
